<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName"
      ><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="dbzc">
        <span slot="label"
          ><i class="iconfont iconcheck"></i><i class="border"></i> 达标自测
        </span>
        <!-- <normalNav :parent="self">
              <button class="GreenSmBtn download" @click="editDialogVisible=true">添加测评项</button>
            </normalNav> -->
        <div class="w_normalNav" :parent="self">
          <!-- <button class="BlueSmBtn" @click="subSeefrom">搜索</button> -->
          <!-- <button class="OrangeSmBtn" @click="reset">重置</button> -->
          <span style="margin-right: 10px;font-size: 16px;font-weight:bold;color:#cacaca">评分:{{pf}}</span>
          <button class="GreenSmBtn" @click="_export">
            导出
          </button>
        </div>
        <div class="w_content j-sb">
          <table v-for="(item, index) in dataList" :key="index" class="card">
            <tr class="flex j-sb" style="border-bottom: 1px solid #3d4963;padding-bottom: 10px;">
              <td>
                <span style="font-size: 16px;font-weight:bold">{{
                  item.typeStr
                }}</span>
                <span> >  &nbsp;{{ item.levelStr }}</span>
              </td>
              <td class="flex btnList">
                <!-- <div>
                    <button class="GreenSmBtn" @click="zpClick(index)">
                      自评
                    </button>
                  </div>
                  <div>
                    <button class="OrangeSmBtn" @click="editClick(item)">
                      编辑
                    </button>
                  </div>
                  <div>
                    <button class="RedSmBtn" @click="del(item)">
                      删除
                    </button>
                  </div> -->
              </td>
            </tr>
            <tr class="flex">
              <td>{{ item.judgeStandard }}</td>
            </tr>
            <tr class="flex">
              <td style="width: 10%;">情况说明</td>
              <td style="width: 90%;">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="item.selfDescription"
                  :disabled="disabled"
                >
                </el-input>
              </td>
            </tr>
            <tr class="flex" style="border-top: 1px solid #3d4963;padding-top: 10px;">
              <td style="width: 20%;">
                <span style="margin-right: 10px;">分值 </span
                >{{ item.totalScore }}
              </td>
              <td style="width: 20%;">
                <span style="margin-right: 10px;">自评得分</span
                >{{ item.selfJudgeScore }}
              </td>
              <td style="width: 56%;" class="flex">
                <span style="margin-right: 10px;">附件</span>
                <div class="flex f-dc">
                  <div >
                  <span class="flex" v-for="(i,index) in item.fileAddressList" :key="index">
                    <a :src="i" :href="i.fileUrl" target="_blank" style="color: #cacaca;">{{ i.fileName }}</a>
                    &nbsp;&nbsp;
                    <!-- <span @click="downloadImage(i.fileUrl,i.fileName)"
                    class="download" style="color: #fff;">下载</span> -->
                    <a :download="i.fileName" :href="i.fileUrl" target="_blank"
                    class="download" style="color: #cacaca;">下载</a>
                  </span>
                </div>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <el-dialog
          class="editDialog"
          title="添加测评项"
          :visible.sync="editDialogVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="form1"
              :model="form1"
              :rules="rule"
              label-position="right"
            >
              <el-form-item label="标题名称" prop="title">
                <el-input
                  v-model="form1.title"
                  placeholder="请输入标题名称"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="评定人">
                <el-input
                  v-model="form1.people"
                  placeholder="请输入评定人"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="评定时间">
                <el-input
                  v-model="form1.date"
                  placeholder="请输入评定时间"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>

          <div slot="footer" class="dialog-footer">
            <el-button class="confirmButton" type="primary" @click="sumbit"
              >提交</el-button
            >
            <!-- <downloadBtn url="extra/standardEvaluation/exportExcel" :params="form1" method="post" :needUserId="true"></downloadBtn> -->
            <el-button
              class="cancelButton"
              type="primary"
              @click="editDialogVisible = false"
              >取消</el-button
            >
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { obj2urlsp, descriptor } from "utils";
export default {
  data() {
    return {
      tabName: "dbzc",
      editLoading: true,
      editDialogVisible: false,
      detailsVisible: false,
      detailsList: [],
      form1: {},
      zpForm: {},
      assetPic: [],
      disabled: true,
      dataList: [],
      standardEvaluationTypeArr: [],
      standardEvaluationLevelArr: [],
      isEdit: false
    };
  },
  watch: {
    editDialogVisible(n) {
      this.$nextTick(() => {
        if (!n) {
          this.form1 = {};
          this.$refs["form1"].resetFields();
        }
      });
      // this.$ref["form1"].resetFields();
      // this.form1={}
    },
    detailsVisible() {
      this.$ref["zpForm"].resetFields();
      // this.xgPicList = [];
      this.zpForm.assetPic = [];
    }
  },
  computed: {
    pf(){
      let pf=0
      this.dataList.forEach(item=>{
        pf = item.selfJudgeScore?item.selfJudgeScore+pf:0+pf
      })
      return pf.toString().indexOf('.')==-1?pf:pf.toFixed(1)
    },
    self() {
      return this;
    },
    rule() {
      let that = this;
      return {
        title: [
          {
            required: true,
            message: "请输入标题名称",
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    del(item) {
      this.$confirm("确定删除测评项?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning"
      }).then(() => {
        this.$axiosget(
          `extra/standardEvaluation/removeTemplateByKey/${item.evaluationId}`
        ).then(res => {
          this.getData();
          this.$message.success("删除成功");
        });
      });
    },
    zpClick(index) {
      this.detailsVisible = true;
      // this.$refs["zpForm"].resetFields();
      this.zpForm = this.dataList[index];
      // this.assetPic=this.dataList[index].fileAddressList
    },
    _export() {
      this.editDialogVisible = true;
      this.isEdit = false;
      // this.$refs["form1"].resetFields();
    },
    sumbit() {
      this.$refs["form1"].validate(valid => {
        if (valid) {
          let arr = [];
          let object = { ...this.form1 };
          if (!this.isEdit) {
            // this.$axiospost(
            //   "extra/standardEvaluation/exportExcel",
            //   object
            // ).then(res => {
            //   if (res.data.status === "10000" || res.data.status === 10000) {
            //     this.$message.success("提交成功！");
            //   }
            //   this.editLoading = false;
            //   this.editDialogVisible = false;
            //   // this.$refs["table_xjrwgl"].getData();
            //   this.getData();
            // });
            this.$axios({
              url: process.env.API_HOST + "extra/standardEvaluation/exportExcel",
              method: "post",
              responseType: "blob",
              data: {
                ...object,
                companyId:localStorage.getItem("companyId")
              },
              headers: {
                'Content-Type': 'application/json', // 如果你发送的是 JSON 数据
                authUserId: localStorage.getItem("authUserId")
              }
            }).then((res) => {
              const a = document.createElement("a");
              // const u = process.env.API_HOST + res.data;
              const u = window.URL.createObjectURL(new Blob([res.data]));
              a.href = u;
              a.style.display = "none";
              a.setAttribute('download', '达标数据.xls');
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            });
          } else {
            this.$refs["form1"].validate(valid => {
              if (valid) {
                let arr = [];
                let object = { ...this.form1 };
                this.$axiospost(
                  "extra/standardEvaluation/updateTemplate",
                  object
                ).then(res => {
                  if (
                    res.data.status === "10000" ||
                    res.data.status === 10000
                  ) {
                    this.$message.success("编辑成功！");
                  }
                  this.editLoading = false;
                  this.editDialogVisible = false;
                  // this.$refs["table_xjrwgl"].getData();
                  this.getData();
                });
              }
            });
          }
        }
      });
    },
    ziping() {
      this.$refs["zpForm"].validate(valid => {
        if (valid) {
          let arr = [];
          let object = { ...this.zpForm };
          if (this.zpForm.assetPic) {
            // this.form1.assetPic.forEach((i)=>arr.push( i.response.data[0] ))
            this.zpForm.assetPic.forEach(i =>
              arr.push({
                fileUrl: i.response.data[0].startsWith("http")
                  ? i.response.data[0]
                  : process.env.fileUrl + "/" + i.response.data[0],
                fileName: i.name
              })
            );
          }
          this.$axiospost("extra/standardEvaluation/fillData", {
            evaluationId: object.evaluationId,
            selfJudgeScore: object.selfJudgeScore,
            selfDescription: object.selfDescription,
            fileList: arr
          }).then(res => {
            if (res.data.status === "10000" || res.data.status === 10000) {
              this.$message.success("提交成功！");
            }
            this.editLoading = false;
            this.detailsVisible = false;
            // this.$refs["table_xjrwgl"].getData();
            this.getData();
          });
        }
      });
    },
    editClick(item) {
      this.editDialogVisible = true;
      this.isEdit = true;
      this.form1 = { ...item };
    },
    downloadImage(src, imgName) {
      let image = new Image();
 
      image.src = src;
  
      image.setAttribute("crossOrigin", "anonymous");
  
      image.onload = function() {
      
          let c = document.createElement("canvas");
  
          c.width = image.width;
  
          c.height = image.height;
  
          c.getContext("2d").drawImage(image, 0, 0, image.width, image.height);
      
          let a = document.createElement("a"); 
  
          a.download = imgName;
  
          a.href = c.toDataURL("image/png");
          a.target = "_blank";
  
          a.click();
      
      }
    },
    getData() {
      this.$axiosget("extra/standardEvaluation/getList").then(res => {
        this.dataList = res.data.data;
      });
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    nextCompany: () => import("public/nextCompany"),
    downloadBtn:() => import('public/download'),
  },
  mounted() {
    this.getData();
    this.$axiosget("operation/dictionaryType/queryByKey", {
      params: {
        key: "standardEvaluationType"
      }
    }).then(res => {
      if (res.data.status === "10000") {
        this.standardEvaluationTypeArr = res.data.data
          ? res.data.data.list
          : [];
      }
    });
    this.$axiosget("operation/dictionaryType/queryByKey", {
      params: {
        key: "standardEvaluationLevel"
      }
    }).then(res => {
      if (res.data.status === "10000") {
        this.standardEvaluationLevelArr = res.data.data
          ? res.data.data.list
          : [];
      }
    });
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom: 1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
/deep/ .editDialog .el-form-item__label {
  text-align: right !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
  font-size: 10px;
}
.el-form-item__content {
  img {
    max-width: 400px;
    max-height: 400px;
  }
}
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.w_content {
  color: #cacaca;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .btnList {
    > div {
      margin: 0 0 0 20px;
    }
  }
  .card {
    border-radius: 6px;
    border: 1px solid #3d4963;
    width: calc(50% - 20px);
    margin: 10px 10px;
    /deep/ .el-textarea.is-disabled .el-textarea__inner{
      background: transparent;
    }
    > tr {
      width: 100%;
      margin: 24px 0px;
      padding: 0 18px;
      td {
        width: auto;
      }
    }
  }
  table {
    border-spacing: 10px;
  }
}
.flex {
  display: flex;
}
.a-c {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-se {
  justify-content: space-evenly;
}
.f-dc {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/standardEvaluation/selfEvaluation/index.vue